import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./Contact.module.css";

import { useDispatch, useSelector } from "react-redux";

import { contact } from "../../redux/actions/userActions";

const Contact = () => {
  const dispatch = useDispatch();

  const contactUs = useSelector((state) => state.contactUs);
  const { loading, success, error } = contactUs;

  const [name, setName] = useState("");
  const [phone, setPhone] = useState();
  const [message, setMessage] = useState();

  const form = {
    message,
    phone,
    name,
  };

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(contact(form));
  };

  return (
    <div className={styles.container}>
      <div className={styles.box}></div>
      <header>
        <div className={styles.topHeader}>
          <Link to="/my-account">
            <i className={styles.backIcon + " fas fa-chevron-left"}></i>
          </Link>
          <h1>Contact Us</h1>
        </div>
      </header>

      <main>
        <form onSubmit={submitHandler}>
          <p>
            Let us know your feedback, queries or issues regarding app or
            features.
          </p>
          <div className={styles.row}>
            <h2>Full Name</h2>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              name="name"
              placeholder="Enter your name"
              required
            />
          </div>
          <div className={styles.row}>
            <h2>Phone Number</h2>
            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="number"
              placeholder="Enter your phone number"
              required
            />
          </div>
          <div className={styles.row}>
            <h2>Message</h2>
            <input
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              type="text"
              placeholder="Enter your Message"
            />
          </div>
          <div>
            <button type="submit">
              {loading ? <span>Loading...</span> : <span>Submit</span>}
              {success && alert(success.message)}
            </button>
            {error && <span>{error}</span>}
          </div>
        </form>
      </main>
    </div>
  );
};

export default Contact;
